package com.zaurh.mapquizwebsite.presentation.screen.main

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.zaurh.mapquizwebsite.domain.repository.AuthRepository
import com.zaurh.mapquizwebsite.domain.repository.UserRepository
import com.zaurh.mapquizwebsite.presentation.screen.home.MainAction
import com.zaurh.mapquizwebsite.presentation.screen.home.MainSideEffect
import com.zaurh.mapquizwebsite.presentation.screen.home.MainUIState
import com.zaurh.mapquizwebsite.utils.EMPTY
import com.zaurh.mapquizwebsite.utils.PreferencesManager
import com.zaurh.mapquizwebsite.utils.onError
import com.zaurh.mapquizwebsite.utils.onSuccess
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class MainViewModel(
    private val authRepository: AuthRepository,
    private val userRepository: UserRepository,
    private val preferencesManager: PreferencesManager
) : ViewModel() {

    private val _uiState = MutableStateFlow(MainUIState())
    val uiState = _uiState.asStateFlow()

    private val _sideEffect = MutableSharedFlow<MainSideEffect>()
    val sideEffect = _sideEffect.asSharedFlow()

    fun onAction(action: MainAction) {
        when (action) {
            MainAction.OnInit -> {
                viewModelScope.launch {
                    userRepository.getUserData().onSuccess { result ->
                        _uiState.update { it.copy(userData = result) }
                    }.onError { code, message ->
                    }
                }
            }

            is MainAction.OnSignInUsernameChange -> {
                _uiState.update { it.copy(signInUsername = action.value) }
            }

            MainAction.OnSignInClicked -> {
                _uiState.update { it.copy(isSignInAlertVisible = true, signInUsername = EMPTY) }
            }

            MainAction.OnSignInAlertDismissed -> {
                _uiState.update { it.copy(isSignInAlertVisible = false) }
            }

            MainAction.OnSignInAlertConfirmed -> {
                viewModelScope.launch {
                    authRepository.signIn(uiState.value.signInUsername).onSuccess { result ->
                        preferencesManager.saveJwtToken(result.token)
                        _uiState.update {
                            it.copy(
                                userData = result.userData,
                                isSignInAlertVisible = false
                            )
                        }
                    }.onError { code, message ->
                    }
                }
            }

            MainAction.OnLogOutClicked -> {
                preferencesManager.clearJWTToken()
                _uiState.update { it.copy(userData = null) }
            }

            MainAction.OnHomeClicked -> {
                viewModelScope.launch {
                    _sideEffect.emit(MainSideEffect.NavigateToHome)
                }
            }

            MainAction.OnDailyRewardsClicked -> {
                viewModelScope.launch {
                    _sideEffect.emit(MainSideEffect.NavigateToDailyRewards)
                }
            }
        }
    }
}